import { Injectable } from '@angular/core';
import _ from 'lodash-es';

@Injectable()
export class GridService {
  public moveToTop(gridElement: any): void {
    if (_.isNull(gridElement) || _.isUndefined(gridElement)) return;

    if (window.pageYOffset > gridElement.offsetTop + gridElement.offsetParent.offsetTop) gridElement.scrollIntoView();
  }
}
